import { useCallback, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Loader } from '@paysense-india-services/elevate-web'

import { PROFILE_API } from '@/constants/api'
import { ROUTES } from '@/constants/routes'

import { useFetch } from '@/hooks/useFetch'

import ErrorPage from '@/components/ErrorPage'
import PageContainer from '@/components/PageContainer'

import LogoutModal from './components/LogoutModal'
import ProfileHeader from './components/ProfileHeader'
import ACTION_TYPES from './utils/actionTypes'
import getProfileComponent from './utils/getProfileComponent'

const ProfilePage = () => {
  const navigate = useNavigate()
  const { data: pageData, loading, error, apiRequest } = useFetch(PROFILE_API, false)

  useEffect(() => {
    apiRequest({})
  }, [apiRequest])

  const finalPageData = pageData
  const { screen: data, subScreen } = finalPageData ?? {}

  const [showLogoutModal, setShowLogoutModal] = useState(false)

  const handleItemClick = useCallback(item => {
    const defaultAction = item?.actions?.default
    if (!defaultAction) return false

    const actionType = defaultAction.type ?? defaultAction.actions

    if (actionType === ACTION_TYPES.BOTTOM_SHEET) {
      setShowLogoutModal(true)
      return true
    }

    return false
  }, [])

  const handleLogout = () => {
    navigate(ROUTES.LOGOUT)
  }

  const handleCloseModal = () => {
    setShowLogoutModal(false)
  }

  const profileComponents = useMemo(() => {
    const sections = data?.sections?.items ?? []
    return sections.map((section, index) => (
      <div className='ew-mb-12' key={section.id ?? `profile-section-${index}`}>
        {getProfileComponent(section, handleItemClick)}
      </div>
    ))
  }, [data, handleItemClick])

  if (loading) {
    return <Loader color='brand' loadingText='Fetching Profile...' pageLoader size='large' />
  }

  if (error) {
    return (
      <ErrorPage
        buttonText='Try again'
        description='Please try again or check back later. Maybe give your phone a nice slap? Hey, it works on the TV remote.'
        isButtonLoading={loading}
        onButtonClick={() => apiRequest({})}
        title='Something went wrong'
      />
    )
  }

  return (
    <>
      <div className='appLayout'>
        <PageContainer className='ew-d-flex ew-flex-column'>
          <ProfileHeader
            data={data}
            headerActions={data?.headerActions}
            onItemClick={handleItemClick}
          />
          {profileComponents}
        </PageContainer>
      </div>

      <LogoutModal
        onClose={handleCloseModal}
        onLogout={handleLogout}
        show={showLogoutModal}
        subScreen={subScreen}
      />
    </>
  )
}

export default ProfilePage
